<template>
  <section class="w-100 container mt-5 mb-5">
    <div v-if="isDefaultFaq">
      <h2 v-if="getExperience" class="title-faq">
        {{ $t(`${plansPage}.${getExperience}.faq.title`) }}
      </h2>
      <h2 v-else class="title-faq">
        {{ title.length ? title[0] : $t('home.newVexels.faqs.defaultTitle') }}
      </h2>
    </div>
    <prismic-rich-text
      v-else
      :field="title"
      class="title-faq text-center w-100"
    ></prismic-rich-text>
    <div
      v-for="(item, index) in items"
      :key="index"
      class="faq-item"
      :style="{ borderBottom: borderBottom }"
    >
      <div class="row w-100" @click="item.isOpen = !item.isOpen">
        <img v-if="item.image" class="mb-2 pl-3 pr-5 pb-3 image-item" :src="item.image" />
        <h3
          class="question"
          :class="!item.image ? 'pl-3' : ''"
          :style="{ color: textColor, textDecoration: textDecoration }"
        >
          {{ item.question }}
        </h3>
      </div>
      <p v-if="isDefaultFaq" class="answer" :class="{ show: item.isOpen }">
        {{ item.answer }}
      </p>
      <prismic-rich-text
        v-else
        :field="item.answer"
        class="answer"
        :class="{ show: item.isOpen }"
        :style="answerStyle"
      ></prismic-rich-text>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Faq',
  props: {
    newVexels: {
      type: Array,
      required: false,
      default: () => []
    },
    customFaq: {
      type: Array,
      required: false,
      default: () => []
    },
    title: {
      type: Array,
      required: false,
      default: () => []
    },
    prismicProps: {
      type: Object,
      required: false,
      default: () => {}
    },
    lifetime: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      items: []
    };
  },
  jsonld() {
    if (!this.items.length) {
      return null;
    }

    const items = this.items.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: this.isDefaultFaq ? item.answer : item.answer[0]?.text
      }
    }));

    return {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: items
    };
  },
  computed: {
    ...mapGetters('experience', ['getExperience']),
    plansPage() {
      return this.lifetime ? 'lifetimePlans' : 'plans';
    },
    isDefaultFaq() {
      return this.customFaq.length === 0;
    },
    textColor() {
      return this.prismicProps?.text_color || '#707070';
    },
    textDecoration() {
      return !this.prismicProps || this.prismicProps?.underline
        ? `text-decoration: underline ${this.textColor}`
        : 'none';
    },
    borderBottom() {
      return this.prismicProps?.border_bottom ? `1px solid ${this.textColor}` : 'none';
    },
    answerStyle() {
      return {
        color: this.textColor,
        marginLeft: !this.isDefaultFaq && this.prismicProps?.itemImage ? '86px !important' : '0px'
      };
    }
  },
  created() {
    this.loadFaq();
  },
  methods: {
    loadFaq() {
      this.items = this.isDefaultFaq ? this.loadDefautlFaq() : this.loadCustomFaq();
    },
    loadCustomFaq() {
      return this.customFaq.map((el) => {
        return {
          question: el.question,
          answer: el.answer,
          image: this.prismicProps?.itemImage ? this.prismicProps.itemImage : '',
          isOpen: false
        };
      });
    },
    loadDefautlFaq() {
      if (this.newVexels.length) {
        return this.newVexels;
      } else {
        return [1, 2, 3, 4, 5, 6, 7, 8].map((n) => {
          return {
            question: this.$t(`${this.plansPage}.${this.getExperience}.faq.question${n}`),
            answer: this.$t(`${this.plansPage}.${this.getExperience}.faq.answer${n}`),
            isOpen: false
          };
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.title-faq {
  color: #787878;
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 25px;
}
.image-item {
  cursor: pointer;
  width: 100px;
  height: 60px;
}
.faq-item {
  margin-bottom: 25px;
}
.question {
  color: #787878;
  text-decoration: underline #787878;
  text-decoration-thickness: 2px;
  text-underline-offset: 7px;
  font-size: 20px;
  font-weight: 400;
  cursor: pointer;
  line-height: 40px;
}
.answer {
  color: #787878;
  max-height: 0px;
  overflow: hidden;
  transition: max-height 0.3s, padding 0.3s;
}
.answer.show {
  padding: 15px 0;
  margin: 0;
  max-height: 1000px;
}
</style>
